import React, { useState, useEffect } from 'react';
import { getAction, getPedido, LoginAyudaDinamica } from 'services/AyudaDinamicaServices';
import { useHistory } from 'react-router-dom';
import '../detallePedido/detallePedido.sass';
import './ayudaDinamica.sass';
import { removeDuplicates } from 'functions/removeDuplicates';
import Loading from 'components/Loading';
import { useStorage64 } from 'hooks/useStorageBase64';
import { useIsMobile } from 'hooks/useIsMobile';
import { CuentanosTuProblemaDesktop } from 'pages/MiCuenta/MisPedidos/AyudaDinamica/AD-Desktop/vista21-cuentanosTuProblema-desktop.js';
import { USERNAME, PASSWORD, PUBLICKEY } from 'constants/general';

export function CuentanosTuProblemaMovil() {
    const history = useHistory();
    const params = history.location.pathname;
    const separar = params.split('/');
    const idPedido = separar[3];
    const [idProductoEstate, setIdProductoEstate] = useState(0);

    const [resultadoPedido, setResultadoPedido] = useState(false);
    const [ima, setima] = useState([]);

    const [loading, setLoading] = useState(false);
    const [action, setAction] = useState(false);
    const [listAction, setListAction] = useState(false);
    const [, setStorageActionId] = useStorage64('storageActionId', '');

    //MOSTRAR LOADING HASTA QUE SE CARGUE LA INFORMACION
    useEffect(() => {
        if ((action.action && action) && (resultadoPedido && resultadoPedido.pedido)) {
            setLoading(false);
        }
        else {
            setLoading(true);
        }
    }, [resultadoPedido, action])

    // revisa si tiene un id de producto
    useEffect(() => {
        let idProducto = 0;
        const urlParams = params.split('/');
        urlParams.shift();

        if (params.includes("/product=")) {
            for (let i = 0; i <= (urlParams.length - 1); i++) {
                if (urlParams[i].indexOf('product=') >= 0) {
                    idProducto = urlParams[i].replace('product=', '')
                }
            }
            setIdProductoEstate(idProducto);
        }
    }, [])

    // obtiene servicio pedido
    useEffect(() => {
        getPedido(idPedido)
            .then(setResultadoPedido)
    }, [])

    // obtengo list action id
    useEffect(() => {
        let reasonId = 8;

        getAction(reasonId)
            .then(setAction)
    }, [])

    // obtengo informacion de pedido
    useEffect(() => {
        let imagenProducto = [];

        if (resultadoPedido) {
            if (resultadoPedido.pedido) {
                // recorre por producto
                if (resultadoPedido.pedido && Number(idProductoEstate) !== 0) {
                    resultadoPedido.pedido[0].products.map((elem, i) =>
                        Number(elem.related_product_id) === Number(idProductoEstate) && imagenProducto.push({ "url": elem.images[0].url, "id": elem.related_product_id })
                    )

                    let limpioImagen = removeDuplicates(imagenProducto, idProductoEstate);
                    setima(limpioImagen);
                }
            }
            else if (resultadoPedido.statusCode && resultadoPedido.statusCode === 401) {
                LoginAyudaDinamica({ username: USERNAME, password: PASSWORD, publicKey: PUBLICKEY })
                setTimeout(() => {
                    getPedido()
                        .then(setResultadoPedido)
                }, 1000);
            }
        }
    }, [resultadoPedido])

    // regresar a la pagina anterior
    const onClose = () => {
        history.goBack(-1);
    }

    // almaceno listado de action
    useEffect(() => {
        let arrayAction = [];
        let reasonId = 8;

        if (action) {
            if (action.action) {
                action.action.map((act, i) =>
                    arrayAction.push({ "id": act.id, "name": act.name })
                )
                setListAction(arrayAction);
            }
            else if (action.statusCode && action.statusCode === 401) {
                LoginAyudaDinamica({ username: USERNAME, password: PASSWORD, publicKey: PUBLICKEY })
                setTimeout(() => {
                    getAction(reasonId)
                        .then(setAction)
                }, 1000);
            }
        }
    }, [action])

    // lleva a pagina solicitar devolucion
    const seleccionoProblema = (id) => {
        let idSeleccionado = id;
        setStorageActionId(idSeleccionado);

        history.push("/mi-cuenta/mis-pedidos/" + idPedido + "/product=" + idProductoEstate + "/solicitar-cambio-devolucion");
    }

    return (
        <>
            {loading && <Loading />}

            <div className="modalDetallePedido full">
                <div className="contentModal">

                    <div className="contentClose">
                        <div className="btn close" onClick={onClose} ></div>
                        <p className="title">¿Cuéntanos tu problema?</p>

                    </div>

                    <div className="dataModal">
                        <div className="contenedorImagenes">
                            <ul>
                                {ima.length > 0 && ima.map((elemento, i) => i <= 2 && <li key={i}><img src={elemento.url} alt={"imagen" + i} width={70} /></li>)}
                            </ul>
                        </div>

                        <div className="boxUlRazones">
                            <ul>
                                {listAction && listAction.map((problem) =>
                                    <li id={problem.id} key={problem.id} onClick={() => seleccionoProblema(problem.id)}>
                                        <span className="nombreRazon">{problem.name}</span>
                                        <span className="iconoRazon"></span>
                                    </li>
                                )}
                            </ul>
                        </div>

                    </div>
                </div>
            </div >
        </>
    )
}

export function CuentanosTuProblema(props) {
    const { isMobile } = useIsMobile();

    return (
        <>
            {isMobile
                ? isMobile === 'desktop'
                    ? <CuentanosTuProblemaDesktop />
                    : isMobile === 'movile'
                        ? null
                        : <CuentanosTuProblemaMovil />
                : null
            }
        </>
    )
}